import { render, staticRenderFns } from "./HistorialProrrateo.vue?vue&type=template&id=ef616e54"
import script from "./HistorialProrrateo.vue?vue&type=script&lang=js"
export * from "./HistorialProrrateo.vue?vue&type=script&lang=js"
import style0 from "./HistorialProrrateo.vue?vue&type=style&index=0&id=ef616e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports